import { render } from "./Legal.vue?vue&type=template&id=6ae8a1de&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"

import "./Legal.vue?vue&type=style&index=0&id=6ae8a1de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae8a1de"]])

export default __exports__